import logo from '../../../../assets/images/logo@2x.png';

export default function Logo(): JSX.Element {
  return (
    <>
      <img src={logo as string} alt='Communikit Logo' />
    </>
  );
}
